import api from "!../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../../../../sass-loader/dist/cjs.js??ruleSet[1].rules[5].use[2]!./_error-pages.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};